import "analytics/snowplow_helper";

// This adds a 'js' class to the root element so that we can style
// things differently when javascript is enabled or disabled
document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");
